import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Scrollbars } from 'react-custom-scrollbars';
import FeatherIcon from 'feather-icons-react';
import { Card, Typography, Row, Col, Dropdown } from "antd";
import { BackIcon, EditIcon } from '../../../../components/Icons/Icons';

const { Title, Text } = Typography;

const DetailsPage = React.memo(({ RightRelatedDetails, entity, EntityRelatedTab, editWon, EntityTabDetails, Maincontent, moreAction, ButtonActions, handleEditChange, PageCancel, UpdatePs, canUpdateDelete, DetailsPageMoreAction, UpdateDataPage }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const updateDataRef = useRef(null);
    const [updateDataHeight, setUpdateDataHeight] = useState(0);
    const handleDropdownOpenChange = (flag) => {
        setDropdownOpen(flag);
    };

    const handleCloseDropdown = () => {
        setDropdownOpen(false);
    };

    // Clone the passed JSX and inject `handleCloseDropdown` prop
    const clonedDropdownContent = React.cloneElement(DetailsPageMoreAction, {
        closeDropdown: handleCloseDropdown,
    });
    useEffect(() => {
        if (!updateDataRef.current) return;
        if (entity !== "Deal" && entity !== "Lead") return; // only for Deal and Lead

        const ro = new ResizeObserver(() => {
            setUpdateDataHeight(updateDataRef.current?.offsetHeight ?? 0);
        });
        ro.observe(updateDataRef.current);
        return () => ro.disconnect();
    }, [UpdateDataPage, entity]);
    return (
        <div style={{ padding: "20px 0px", margin: "auto" }}>
            <Row gutter={[20, 20]} justify="center" style={{ minHeight: "100vh" }}>
                <Col xxl={6} xl={6} lg={8} md={10} sm={24} xs={24}>
                    <Card style={{ textAlign: "center", flex: 1 }} className="DetailsCard" t>
                        <Scrollbars autoHide style={{ height: 1010 }}>
                            <div style={{ padding: "0px 16px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "15px" }}>
                                    <div className='Hover-Refresh2 back-hover1 able-style'
                                        role="button"
                                        tabIndex={0} title='Back'
                                        onClick={() => PageCancel()}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter' || event.key === ' ') {
                                                PageCancel()
                                            }
                                        }}
                                        aria-label='Back'
                                    > <BackIcon height={20} width={20} /></div>
                                    {editWon ?
                                        <div className="disabled-style"
                                        > <EditIcon height={20} width={20} /></div> :
                                        UpdatePs ?
                                            <div className={!canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                                                role="button"
                                                tabIndex={0} title='Edit'
                                                onClick={!canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) ? undefined : () => { handleEditChange() }}
                                                onKeyDown={(event) => {
                                                    if (canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId) && (event.key === 'Enter' || event.key === ' ')) {
                                                        handleEditChange()
                                                    }
                                                }}
                                                aria-label='edit'
                                            > <EditIcon height={20} width={20} /></div>
                                            :
                                            <div className={entity === '?FCASE' ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                                                role="button"
                                                tabIndex={0} title='Edit'
                                                onClick={entity === '?FCASE' ? undefined : () => { handleEditChange() }}
                                                onKeyDown={(event) => {
                                                    if (entity !== '?FCASE' && (event.key === 'Enter' || event.key === ' ')) {
                                                        handleEditChange()
                                                    }
                                                }}
                                                aria-label='edit'
                                            > <EditIcon height={20} width={20} /></div>}
                                </div>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }} className="Detailspage-Picture">
                                    <figure className="photoUpload align-center-v" >
                                        {Maincontent?.profile !== null && Maincontent?.profile !== undefined && Maincontent?.profile !== "" ?
                                            <img src={Maincontent.profile} alt="" />
                                            :
                                            <span className={`details_span_Tag ${Maincontent.Classname}`}>
                                                {Maincontent?.letterIcon?.slice(0, 1).toUpperCase()}
                                            </span>
                                        }
                                    </figure>
                                </div>
                                <Title level={4} style={{ marginTop: 10, marginBottom: 5 }}>{Maincontent?.name}</Title>
                                <Text type="secondary">{Maincontent?.subName}</Text>
                                {ButtonActions &&
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", margin: "15px 0px" }}>
                                        {ButtonActions?.map((item, index) => (
                                            <div key={index}>{item.Actions}</div>
                                        ))}
                                        {moreAction === "Yes" &&
                                            <Dropdown
                                                placement="bottom"
                                                open={dropdownOpen}
                                                onOpenChange={handleDropdownOpenChange}
                                                overlay={clonedDropdownContent}
                                                trigger={['click']}
                                            >
                                                <div className="Hover-Refresh2 back-hover1 able-style">
                                                    <FeatherIcon icon="more-horizontal" size={20} />
                                                </div>
                                            </Dropdown>}
                                    </div>}
                                {Maincontent?.mainAction &&
                                    <div style={{ marginBottom: 5 }}>
                                        {Maincontent?.mainAction}
                                    </div>}
                                {EntityTabDetails}
                            </div>
                        </Scrollbars>
                    </Card>
                </Col>
                <Col xxl={12} xl={12} lg={16} md={14} sm={24} xs={24} >
                    {UpdateDataPage ?
                        <Card style={{ flex: 1, marginBottom: 15 }} className="DetailsCard" ref={updateDataRef}>
                            <div style={{ padding: "0px 16px" }}>
                                {UpdateDataPage}
                            </div >
                        </Card> : <></>}
                    <Card style={{ flex: 1 }} className="DetailsCard">
                        <Scrollbars autoHide style={{
                            // height: entity === "Deal" ? 0.8 * 1027 : (entity === "Lead" || entity === "Task") ? 0.8 * 1057 : 1010
                            height: (() => {
                                const base = entity === "Task" ? 0.8 * 1057 : 1010;
                                const shouldSubtract = (entity === "Deal" || entity === "Lead") && updateDataHeight > 0;
                                return shouldSubtract ? 1010 - updateDataHeight - 15 : base;
                            })()
                        }}>
                            <div style={{ padding: "0px 16px" }}>
                                {EntityRelatedTab}
                            </div>
                        </Scrollbars>
                    </Card>
                </Col>
                <Col xxl={6} xl={6} lg={12} md={16} sm={24} xs={24}>
                    <Card style={{ flex: 1 }} className="DetailsCard">
                        <Scrollbars autoHide style={{ height: 1010 }}>
                            <div style={{ padding: "0px 16px" }}>
                                {RightRelatedDetails}
                            </div>
                        </Scrollbars>
                    </Card>
                </Col>
            </Row>
        </div >
    );
});

DetailsPage.propTypes = {
    handleEditChange: PropTypes.func.isRequired,
    canUpdateDelete: PropTypes.func.isRequired,
    PageCancel: PropTypes.func.isRequired,
    entity: PropTypes.string.isRequired,
    UpdatePs: PropTypes.object.isRequired,
    DetailsPageMoreAction: PropTypes.object.isRequired,
    EntityTabDetails: PropTypes.node,
    EntityRelatedTab: PropTypes.node,
    UpdateDataPage: PropTypes.node,
    RightRelatedDetails: PropTypes.node,
    Maincontent: PropTypes.object.isRequired,
    ButtonActions: PropTypes.object.isRequired,
    moreAction: PropTypes.string.isRequired,
    editWon: PropTypes.bool.isRequired,
};

export default DetailsPage;
